import { KpiData } from './Metrics.model';
import { IDualKPIData } from '../../components/Molecules/DualKpiWidget/DualKPIWidget.types';

export function mapMetricDataToDualKpiData(input: KpiData[]): IDualKPIData[] {
  return (input.filter(Boolean).map(item => {
    return { label: item.label, value: item.value };
  }) || []) as IDualKPIData[];
}
